import React, { useContext, useEffect, useState } from "react";

import "./stylesUsersNew.css";
import Layout from "../../CommonComponents/Layout/Layout";

import AppContext from "../../../context/AppContext";
import { KPI_CARD_BACKGROUND, SIDER_TABS } from "../../../utils/Constants";
import CustomAutoComplete from "../../CommonComponents/CustomAutoComplete/CustomAutoComplete";
import CustomDatePicker from "../../CommonComponents/CustomDatePicker/CustomDatePicker";

import dayjs from "dayjs";
import { ChevronDown, ChevronUp, Filter } from "react-feather";
import { Select } from "antd";

import createPrivateAdminPanelInstance from "../../../api/PrivateAdminPanelInstance";
import ExpandableRowTable from "../../CommonComponents/ExpandableRowTable/ExpandableRowTable";
import UsersTable from "./UsersTable";

function UsersNew() {
  const token = JSON.parse(localStorage.getItem("token"));
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.IdToken,
    true
  );

  const { setActiveSidebarTab } = useContext(AppContext);

  const todayRange = [dayjs(), dayjs()];
  const tabs = ["Sportsbook KPI"];

  const [activeTab, setActiveTab] = useState("Sportsbook KPI");
  const [isApiRunning, setIsApiRunning] = useState(true);
  const [showExtraFilters, setShowExtraFilters] = useState(false);
  const [sportsBookDates, setSportsBookDates] = useState(todayRange);
  const [sportsbookData, setSportsBookData] = useState({
    sum_turnover: 0,
    total_margin: 0,
    previous_sum_turnover: 0,
    total_bet_count: 0,
    total_betcount_change: 0,
    total_players_engaged: 0,
    sum_total_players: 0,
    total_avg_bet_amount: 0,
    total_avg_bet_amount_change: 0,
  });
  const [sportRadarPerformanceData, setSportRadarPerformanceData] = useState({
    totalTurnover: 0,
    turnoverChange: 0,
    totalGGR: 0,
    changePercentageGGR: 0,
    totalBets: 0,
    betsCountChange: 0,
    margin: 0,
    marginChange: 0,
    avgBetAmount: 0,
    avgBetAmountChange: 0,
    playersEngaged: 0,
    totalPlayers: 0,
    playersPercentage: 0,
    timeSeries: [],
  });
  const [odinPerformanceData, setOdinPerformanceData] = useState({
    totalTurnover: 0,
    turnoverChange: 0,
    totalGGR: 0,
    changePercentageGGR: 0,
    totalBets: 0,
    betsCountChange: 0,
    margin: 0,
    marginChange: 0,
    avgBetAmount: 0,
    avgBetAmountChange: 0,
    playersEngaged: 0,
    totalPlayers: 0,
    playersPercentage: 0,
    timeSeries: [],
  });
  const [dstPerformanceData, setDstPerformanceData] = useState({
    totalTurnover: 0,
    turnoverChange: 0,
    totalGGR: 0,
    changePercentageGGR: 0,
    totalBets: 0,
    betsCountChange: 0,
    margin: 0,
    marginChange: 0,
    avgBetAmount: 0,
    avgBetAmountChange: 0,
    playersEngaged: 0,
    totalPlayers: 0,
    playersPercentage: 0,
    timeSeries: [],
  });
  const [provider, setProvider] = useState([
    {
      label: "SportRadar",
      value: 1,
    },
    {
      label: "Oddin",
      value: 2,
    },
    {
      label: "PropCity",
      value: 3,
    },
  ]);
  const [sport, setSport] = useState([]);
  const [league, setLeague] = useState([]);
  const [selectedProviders, setSelectedProviders] = useState([]);

  useEffect(() => {
    setActiveSidebarTab(SIDER_TABS.SPORTSBOOK, "Sportsbook");
  }, [setActiveSidebarTab]);

  // useEffect(() => {
  //   setIsApiRunning(true);
  //   setTimeout(() => {
  //     setIsApiRunning(false);
  //   }, 20);
  // }, []);

  const getSportsBookData = async (queryString) => {
    setIsApiRunning(true);
    console.log("RUNNING SPORTSBOOK API");
    const data1 = {
      message: "Success successfully",
      data: {
        ts_agg_data: {
          total_turnover: {
            "2025-04-01": "13.00",
            "2025-04-02": "196.00",
            "2025-04-03": "34.50",
            "2025-04-04": "34.00",
          },
          sportradar_turnover: {
            "2025-04-01": "3.00",
            "2025-04-02": "196.00",
            "2025-04-03": "34.50",
            "2025-04-04": "27.00",
          },
          dst_turnover: { "2025-04-04": "5.00" },
          oddin_turnover: { "2025-04-01": "10.00", "2025-04-04": "2.00" },
          sum_sportradar_turnover: "260.50",
          sum_dst_turnover: "5.00",
          sum_oddin_turnover: "12.00",
          sum_turnover: "277.50",
          sum_cashout: "20.94",
          sportradar_avg_bet_amount: 4.92,
          dts_avg_bet_amount: 1.0,
          oddin_avg_bet_amount: 4.0,
          total_avg_bet_amount: 4.55,
          sportradar_bet_counts: 53,
          dst_bet_count: 5,
          oddin_bet_count: 3,
          total_bet_count: 61,
          total_ggr: {
            "2025-04-01": "13.00",
            "2025-04-02": "192.50",
            "2025-04-03": "16.44",
            "2025-04-04": "28.37",
          },
          sportradar_ggr: {
            "2025-04-01": "3.00",
            "2025-04-02": "192.50",
            "2025-04-03": "16.44",
            "2025-04-04": "27.00",
          },
          dst_ggr: { "2025-04-04": "0.50" },
          oddin_ggr: { "2025-04-01": "10.00", "2025-04-04": "0.87" },
          sum_sportradar_ggr: "238.94",
          sum_dst_ggr: "0.50",
          sum_oddin_ggr: "10.87",
          sum_ggr: "250.31",
          sportradar_margin: 91.72,
          dst_margin: 10.0,
          oddin_margin: 90.58,
          total_margin: 90.2,
          sportradar_players_engaged: 6,
          dst_players_engaged: 2,
          oddin_players_engaged: 1,
          total_players_engaged: 7,
          sum_total_players: 46,
          previous_sum_cashout: 9.66,
          previous_sum_turnover: 27.5,
          change_percentage_turnover: 909.09,
          total_betcount_change: 0.0,
          total_avg_bet_amount_change: 0.0,
          sportradar_turnover_change: 0.0,
          dst_turnover_change: 0.0,
          oddin_turnover_change: 0.0,
          sportradar_avg_bet_amount_change: 0.0,
          dst_avg_bet_amount_change: 0.0,
          oddin_avg_bet_amount_change: 0.0,
          sportradar_bets_count_change: 0.0,
          dst_bets_count_change: 100.0,
          oddin_bets_count_change: 100.0,
          previous_sum_ggr: 8.86,
          change_percentage_ggr: 2725.17,
          sportradar_margin_change: [3.4],
          dst_margin_change: [0],
          oddin_margin_change: [0],
        },
      },
      success: true,
    };

    try {
      // const response = await PrivateAdminPanelInstance?.get(
      //   `/dashboard/finance/sportsbook?${queryString}`
      // );
      const data = data1.data;

      const requests = [
        PrivateAdminPanelInstance?.get(
          `/dashboard/sportsbook/turnover-metrics?${queryString}`
        ),
        PrivateAdminPanelInstance?.get(
          `/dashboard/sportsbook/turnover-metrics?${queryString}&previous=1`
        ),
        PrivateAdminPanelInstance?.get(
          `/dashboard/sportsbook/ggr-metrics?${queryString}`
        ),
        PrivateAdminPanelInstance?.get(
          `/dashboard/sportsbook/ggr-metrics?${queryString}&previous=1`
        ),
        PrivateAdminPanelInstance?.get(
          `/dashboard/sportsbook/betcount-metrics?${queryString}`
        ),
        PrivateAdminPanelInstance?.get(
          `/dashboard/sportsbook/betcount-metrics?${queryString}&previous=1`
        ),
        PrivateAdminPanelInstance?.get(
          `/dashboard/sportsbook/players-engaged-metrics?${queryString}`
        ),
        PrivateAdminPanelInstance?.get(
          `/dashboard/sportsbook/players-engaged-metrics?${queryString}&previous=1`
        ),
        PrivateAdminPanelInstance?.get(
          `/dashboard/sportsbook/turnover-timeseries-metrics?${queryString}`
        ),
        PrivateAdminPanelInstance?.get(
          `/dashboard/sportsbook/form-select-data`
        ),
      ];

      const responses = await Promise.allSettled(requests);

      const [
        sportsbookTurnoverResponse,
        sportsbookTurnoverPreviousResponse,
        sportsbookGGRResponse,
        sportsbookGGRPreviousResponse,
        sportsbookBetCountResponse,
        sportsbookBetCountPreviousResponse,
        sportsbookPlayersEngagedResponse,
        sportsbookPlayersEngagedPreviousResponse,
        sportsbookTimeSeriesResponse,
        sportsbookSelecResponse,
      ] = responses;

      if (sportsbookTurnoverResponse?.status === "fulfilled") {
        const sportsbookTurnoverData =
          sportsbookTurnoverResponse?.value?.data?.data;
        setSportsBookData((prev) => ({
          ...prev,
          sum_turnover: sportsbookTurnoverData?.ts_agg_data?.total_turnover,
        }));
        setSportRadarPerformanceData((prev) => ({
          ...prev,
          totalTurnover: sportsbookTurnoverData?.ts_agg_data?.sportradar?.total,
        }));
        setOdinPerformanceData((prev) => ({
          ...prev,
          totalTurnover: sportsbookTurnoverData?.ts_agg_data?.oddin?.total,
        }));
        setDstPerformanceData((prev) => ({
          ...prev,
          totalTurnover: sportsbookTurnoverData?.ts_agg_data?.dst?.total,
        }));
      }

      if (sportsbookTurnoverPreviousResponse?.status === "fulfilled") {
        const sportsbookTurnoverPreviousData =
          sportsbookTurnoverPreviousResponse?.value?.data?.data;
        setSportsBookData((prev) => ({
          ...prev,
          previous_sum_turnover:
            sportsbookTurnoverPreviousData?.ts_agg_data?.total_turnover,
        }));
        setSportRadarPerformanceData((prev) => ({
          ...prev,
          turnoverChange:
            sportsbookTurnoverPreviousData?.ts_agg_data?.sportradar?.total,
        }));
        setOdinPerformanceData((prev) => ({
          ...prev,
          turnoverChange:
            sportsbookTurnoverPreviousData?.ts_agg_data?.oddin?.total,
        }));
        setDstPerformanceData((prev) => ({
          ...prev,
          turnoverChange:
            sportsbookTurnoverPreviousData?.ts_agg_data?.dst?.total,
        }));
      }

      if (sportsbookGGRResponse?.status === "fulfilled") {
        const sportsbookGGRData = sportsbookGGRResponse?.value?.data?.data;
        setSportRadarPerformanceData((prev) => ({
          ...prev,
          totalGGR: sportsbookGGRData?.ts_agg_data?.sportradar?.total,
        }));
        setOdinPerformanceData((prev) => ({
          ...prev,
          totalGGR: sportsbookGGRData?.ts_agg_data?.oddin?.total,
        }));
        setDstPerformanceData((prev) => ({
          ...prev,
          totalGGR: sportsbookGGRData?.ts_agg_data?.dst?.total,
        }));
      }

      if (sportsbookGGRPreviousResponse?.status === "fulfilled") {
        const sportsbookGGRPreviousData =
          sportsbookGGRPreviousResponse?.value?.data?.data;
        setSportRadarPerformanceData((prev) => ({
          ...prev,
          changePercentageGGR:
            sportsbookGGRPreviousData?.ts_agg_data?.sportradar?.total,
        }));
        setOdinPerformanceData((prev) => ({
          ...prev,
          changePercentageGGR:
            sportsbookGGRPreviousData?.ts_agg_data?.oddin?.total,
        }));
        setDstPerformanceData((prev) => ({
          ...prev,
          changePercentageGGR:
            sportsbookGGRPreviousData?.ts_agg_data?.dst?.total,
        }));
      }

      if (sportsbookBetCountResponse?.status === "fulfilled") {
        const sportsbookBetCountData =
          sportsbookBetCountResponse?.value?.data?.data;
        setSportsBookData((prev) => ({
          ...prev,
          total_bet_count: sportsbookBetCountData?.ts_agg_data?.total_betcount,
        }));
        setSportRadarPerformanceData((prev) => ({
          ...prev,
          totalBets: sportsbookBetCountData?.ts_agg_data?.sportradar?.total,
        }));
        setOdinPerformanceData((prev) => ({
          ...prev,
          totalBets: sportsbookBetCountData?.ts_agg_data?.oddin?.total,
        }));
        setDstPerformanceData((prev) => ({
          ...prev,
          totalBets: sportsbookBetCountData?.ts_agg_data?.dst?.total,
        }));
      }

      if (sportsbookBetCountPreviousResponse?.status === "fulfilled") {
        const sportsbookBetCountPreviousData =
          sportsbookBetCountPreviousResponse?.value?.data?.data;
        setSportsBookData((prev) => ({
          ...prev,
          total_betcount_change:
            sportsbookBetCountPreviousData?.ts_agg_data?.total_betcount,
        }));
        setSportRadarPerformanceData((prev) => ({
          ...prev,
          betsCountChange:
            sportsbookBetCountPreviousData?.ts_agg_data?.sportradar?.total,
        }));
        setOdinPerformanceData((prev) => ({
          ...prev,
          betsCountChange:
            sportsbookBetCountPreviousData?.ts_agg_data?.oddin?.total,
        }));
        setDstPerformanceData((prev) => ({
          ...prev,
          betsCountChange:
            sportsbookBetCountPreviousData?.ts_agg_data?.dst?.total,
        }));
      }

      if (sportsbookPlayersEngagedResponse?.status === "fulfilled") {
        const sportsbookPlayersEngagedData =
          sportsbookPlayersEngagedResponse?.value?.data?.data;
        setSportsBookData((prev) => ({
          ...prev,
          total_players_engaged:
            sportsbookPlayersEngagedData?.ts_agg_data
              ?.total_unique_players_engaged,
        }));
        setSportRadarPerformanceData((prev) => ({
          ...prev,
          playersEngaged:
            sportsbookPlayersEngagedData?.ts_agg_data?.sportradar
              ?.players_engaged,
        }));
        setOdinPerformanceData((prev) => ({
          ...prev,
          playersEngaged:
            sportsbookPlayersEngagedData?.ts_agg_data?.oddin?.players_engaged,
        }));
        setDstPerformanceData((prev) => ({
          ...prev,
          playersEngaged:
            sportsbookPlayersEngagedData?.ts_agg_data?.dst?.players_engaged,
        }));
      }

      if (sportsbookPlayersEngagedPreviousResponse?.status === "fulfilled") {
        const sportsbookPlayersEngagedPreviousData =
          sportsbookPlayersEngagedPreviousResponse?.value?.data?.data;
        // parece que está vazio aqui, talvez você ainda vá usar?
      }

      if (sportsbookTimeSeriesResponse?.status === "fulfilled") {
        const sportsbookTimeSeriesData =
          sportsbookTimeSeriesResponse?.value?.data?.data;
        if (sportsbookTimeSeriesData?.ts_agg_data?.sportradar?.timestamps) {
          setSportRadarPerformanceData((prev) => ({
            ...prev,
            timeSeries:
              sportsbookTimeSeriesData.ts_agg_data.sportradar.timestamps,
          }));
        }
        if (sportsbookTimeSeriesData?.ts_agg_data?.oddin?.timestamps) {
          setOdinPerformanceData((prev) => ({
            ...prev,
            timeSeries: sportsbookTimeSeriesData.ts_agg_data.oddin.timestamps,
          }));
        }
        if (sportsbookTimeSeriesData?.ts_agg_data?.dst?.timestamps) {
          setDstPerformanceData((prev) => ({
            ...prev,
            timeSeries: sportsbookTimeSeriesData.ts_agg_data.dst.timestamps,
          }));
        }
      }

      if (sportsbookSelecResponse?.status === "fulfilled") {
        const sportsbookSelecData = sportsbookSelecResponse?.value?.data?.data;

        setSport(
          sportsbookSelecData?.ts_agg_data.sports.map((item) => ({
            label: item.name,
            value: item.id,
          }))
        );
        setLeague(
          sportsbookSelecData?.ts_agg_data.leagues.map((item) => ({
            label: item.name,
            value: item.id,
          }))
        );
      }

      // setSportRadarPerformanceData({
      //   timeSeries: data.ts_agg_data.sportradar_turnover,
      //   totalTurnover: data.ts_agg_data.sum_sportradar_turnover,
      //   turnoverChange: data.ts_agg_data.sportradar_turnover_change,
      //   totalGGR: data.ts_agg_data.sum_sportradar_ggr,
      //   changePercentageGGR: data.ts_agg_data.change_percentage_ggr,
      //   totalBets: data.ts_agg_data.sportradar_bet_counts,
      //   betsCountChange: data.ts_agg_data.sportradar_bets_count_change,
      //   margin: data.ts_agg_data.sportradar_margin,
      //   marginChange: data.ts_agg_data.sportradar_margin_change[0],
      //   avgBetAmount: data.ts_agg_data.sportradar_avg_bet_amount,
      //   avgBetAmountChange: data.ts_agg_data.sportradar_avg_bet_amount_change,
      //   playersEngaged: data.ts_agg_data.sportradar_players_engaged,
      //   totalPlayers: data.ts_agg_data.sum_total_players,
      //   playersPercentage: Number(
      //     (
      //       (data.ts_agg_data.sportradar_players_engaged * 100) /
      //       data.ts_agg_data.sum_total_players
      //     ).toFixed(2)
      //   ),
      // });
      // setOdinPerformanceData({
      //   timeSeries: data.ts_agg_data.oddin_turnover,
      //   totalTurnover: data.ts_agg_data.sum_oddin_turnover,
      //   turnoverChange: data.ts_agg_data.oddin_turnover_change,
      //   totalGGR: data.ts_agg_data.sum_oddin_ggr,
      //   changePercentageGGR: data.ts_agg_data.change_percentage_ggr,
      //   totalBets: data.ts_agg_data.oddin_bet_count,
      //   betsCountChange: data.ts_agg_data.oddin_bets_count_change,
      //   margin: data.ts_agg_data.oddin_margin,
      //   marginChange: data.ts_agg_data.oddin_margin_change[0],
      //   avgBetAmount: data.ts_agg_data.oddin_avg_bet_amount,
      //   avgBetAmountChange: data.ts_agg_data.oddin_avg_bet_amount_change,
      //   playersEngaged: data.ts_agg_data.oddin_players_engaged,
      //   totalPlayers: data.ts_agg_data.sum_total_players,
      //   playersPercentage: Number(
      //     (
      //       (data.ts_agg_data.oddin_players_engaged * 100) /
      //       data.ts_agg_data.sum_total_players
      //     ).toFixed(2)
      //   ),
      // });
      // setDstPerformanceData({
      //   timeSeries: data.ts_agg_data.dst_turnover,
      //   totalTurnover: data.ts_agg_data.sum_dst_turnover,
      //   turnoverChange: data.ts_agg_data.dst_turnover_change,
      //   totalGGR: data.ts_agg_data.sum_dst_ggr,
      //   changePercentageGGR: data.ts_agg_data.change_percentage_ggr,
      //   totalBets: data.ts_agg_data.dst_bet_count,
      //   betsCountChange: data.ts_agg_data.dst_bets_count_change,
      //   margin: data.ts_agg_data.dst_margin,
      //   marginChange: data.ts_agg_data.dst_margin_change[0],
      //   avgBetAmount: data.ts_agg_data.dts_avg_bet_amount,
      //   avgBetAmountChange: data.ts_agg_data.dst_avg_bet_amount_change,
      //   playersEngaged: data.ts_agg_data.dst_players_engaged,
      //   totalPlayers: data.ts_agg_data.sum_total_players,
      //   playersPercentage: Number(
      //     (
      //       (data.ts_agg_data.dst_players_engaged * 100) /
      //       data.ts_agg_data.sum_total_players
      //     ).toFixed(2)
      //   ),
      // });
    } catch (error) {
      console.log("error fetching sportsbook data", error);
    } finally {
      setIsApiRunning(false);
    }
  };

  const match = [
    {
      value: "Match 1",
      label: "Match 1",
    },
    {
      value: "Match 2",
      label: "Match 2",
    },
    {
      value: "Match 3",
      label: "Match 3",
    },
  ];
  const SearchOptions = [
    {
      value: "Email",
      label: "Email",
    },
    {
      value: "First & Last Name",
      label: "First & Last Name",
    },
    {
      value: "Username",
      label: "Username",
    },
    {
      value: "Phone Number",
      label: "Phone Number",
    },
    {
      value: "User ID",
      label: "User ID",
    },
  ];

  const LocationOptions = [
    {
      value: "Seattle",
      label: "Seattle",
    },
    {
      value: "Austin",
      label: "Austin",
    },
    {
      value: "Denver",
      label: "Denver",
    },
    {
      value: "New York",
      label: "New York",
    },
  ];
  const PlatformOptions = [
    {
      value: "IOS",
      label: "IOS",
    },
    {
      value: "Android",
      label: "Android",
    },
    {
      value: "Desktop",
      label: "Desktop",
    },
    {
      value: "Mac ",
      label: "Mac",
    },
    {
      value: "Windows",
      label: "Windows",
    },
  ];
  const StatusOptions = [
    {
      value: "Active",
      label: "Active",
    },
    {
      value: "Suspended",
      label: "Suspended",
    },
    {
      value: "Limited",
      label: "Limited",
    },
    {
      value: "Deleted",
      label: "Deleted",
    },
  ];
  const DeviceTypeOptions = [
    {
      value: "Mobile",
      label: "Mobile",
    },
    {
      value: "Desktop",
      label: "Desktop",
    },
    {
      value: "Tablet",
      label: "Tablet",
    },
  ];
  const BettorsBettingBehaviorOptions = [
    {
      value: "Cash",
      label: "Cash",
    },
    {
      value: "Coin",
      label: "Coin",
    },
    {
      value: "Both",
      label: "Both",
    },
    {
      value: "Never",
      label: "Never",
    },
  ];

  return (
    <Layout>
      <div className="users-new-container">
        <div className="users-new">
          <>
            <div className="head-controls">
              <div className="header-text-container">
                <p className="header-text">Players List</p>
              </div>
            </div>

            <div className="users-new-content">
              <div className="users-new-content-header">
                <div className="users-new-autocomplete-container">
                  <div className="users-new-selectorss">
                    <div className="users-new-selector">
                      <Select
                        mode="single"
                        placeholder="Not Selected"
                        onChange={() => {}}
                        options={SearchOptions}
                      />
                    </div>
                  </div>
                  <CustomAutoComplete
                    placeholder="Search"
                    handleChange={() => {}}
                    clearOptions={() => {}}
                  />
                  <div className="divider"></div>
                  <div
                    className="filter-buttons"
                    onClick={() => setShowExtraFilters(!showExtraFilters)}
                  >
                    <Filter className="filter-icon" />
                    {showExtraFilters ? (
                      <ChevronUp className="filter-icon" />
                    ) : (
                      <ChevronDown className="filter-icon" />
                    )}
                  </div>
                </div>
              </div>
              <div
                className="users-new-selectors"
                style={{ display: showExtraFilters ? "flex" : "none" }}
              >
                <div className="users-new-selector">
                  <span>Registration Date</span>
                  <CustomDatePicker
                    getData={() => {}}
                    dates={sportsBookDates}
                    setDates={setSportsBookDates}
                    showPresets={true}
                  />
                </div>
                <div className="users-new-selector">
                  <span>Location</span>
                  <Select
                    mode="multiple"
                    placeholder="Not Selected"
                    onChange={() => {}}
                    options={LocationOptions}
                  />
                </div>
                <div className="users-new-selector">
                  <span>Platform</span>
                  <Select
                    mode="multiple"
                    placeholder="Not Selected"
                    onChange={() => {}}
                    options={PlatformOptions}
                  />
                </div>
                <div className="users-new-selector">
                  <span>Status</span>
                  <Select
                    mode="multiple"
                    placeholder="Not Selected"
                    onChange={() => {}}
                    options={StatusOptions}
                  />
                </div>
                <div className="users-new-selector">
                  <span>Device Type</span>
                  <Select
                    mode="multiple"
                    placeholder="Not Selected"
                    onChange={() => {}}
                    options={DeviceTypeOptions}
                  />
                </div>
              </div>
              <div
                className="users-new-selectors"
                style={{ display: showExtraFilters ? "flex" : "none" }}
              >
                <div className="users-new-selector">
                  <span>Bettors betting behavior</span>
                  <Select
                    mode="multiple"
                    placeholder="Not Selected"
                    onChange={() => {}}
                    options={BettorsBettingBehaviorOptions}
                    style={{ width: "18%" }}
                  />
                </div>
              </div>
              <div
                className="users-new-selector-action-buttons"
                style={{ display: showExtraFilters ? "flex" : "none" }}
              >
                <button className="clear">Clear Filters</button>
                <button className="apply">Apply</button>
              </div>
              <UsersTable />
            </div>
          </>
        </div>
      </div>
    </Layout>
  );
}

export default UsersNew;
